module.exports = __webpack_public_path__ + "static/media/midi.9fb7e445.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/midi.svg
// module id = 599
// module chunks = 0